import {
  GET_PROFILE_DETAILS,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_PROFILE_DETAILS_FAILURE,
  SAVE_PROFILE_DETAILS,
  SAVE_PROFILE_DETAILS_SUCCESS,
  SAVE_PROFILE_DETAILS_FAILURE,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS_SUCCESS,
  UPDATE_PROFILE_DETAILS_FAILURE,
} from "../Action/actionTypes";

interface ProfileDetailsState {
  profileData: {
    type: string;
    isLoggedInFirstTime: boolean;
    initialSatge: boolean;
  };
  loading: boolean;
  error: string;
}

const initialState: ProfileDetailsState = {
  profileData: {
    type: "",
    isLoggedInFirstTime: false,
    initialSatge: true,
  },
  loading: false,
  error: "",
};

const profileDetailsReducer = (
  state = initialState,
  action: any
): ProfileDetailsState => {
  switch (action.type) {
    case GET_PROFILE_DETAILS:
    case SAVE_PROFILE_DETAILS:
    case UPDATE_PROFILE_DETAILS:
      return {
        ...state,
        loading: true,
      };

    case GET_PROFILE_DETAILS_SUCCESS:
    case SAVE_PROFILE_DETAILS_SUCCESS:
    case UPDATE_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        profileData: action.payload,
        loading: false,
      };

    case GET_PROFILE_DETAILS_FAILURE:
    case SAVE_PROFILE_DETAILS_FAILURE:
    case UPDATE_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default profileDetailsReducer;
